import { CountriesTranslations, TranslateFunction } from '@locales/generated';

// Helper to get flag emoji from alpha2 code
const getFlagEmoji = (alpha2: string) =>
  String.fromCodePoint(
    ...alpha2
      .toUpperCase()
      .split('')
      .map(char => 0x1f1e6 + char.charCodeAt(0) - 65),
  );

// THis file is based on the response from getRegistryStaticData.countries
// ideally we can eliminate this mapping by having our APIs use country codes instead of country names (https://withjoy.atlassian.net/browse/TRAV-922)
const countries: Record<
  Lowercase<keyof CountriesTranslations<TranslateFunction>>,
  {
    alpha3: string;
    name: string;
    emoji?: string;
  }
> = {
  af: { alpha3: 'AFG', name: 'Afghanistan', emoji: getFlagEmoji('AF') },
  al: { alpha3: 'ALB', name: 'Albania', emoji: getFlagEmoji('AL') },
  dz: { alpha3: 'DZA', name: 'Algeria', emoji: getFlagEmoji('DZ') },
  as: { alpha3: 'ASM', name: 'American Samoa', emoji: getFlagEmoji('AS') },
  ad: { alpha3: 'AND', name: 'Andorra', emoji: getFlagEmoji('AD') },
  ao: { alpha3: 'AGO', name: 'Angola', emoji: getFlagEmoji('AO') },
  ai: { alpha3: 'AIA', name: 'Anguilla', emoji: getFlagEmoji('AI') },
  aq: { alpha3: 'ATA', name: 'Antarctica', emoji: getFlagEmoji('AQ') },
  ag: { alpha3: 'ATG', name: 'Antigua and Barbuda', emoji: getFlagEmoji('AG') },
  ar: { alpha3: 'ARG', name: 'Argentina', emoji: getFlagEmoji('AR') },
  am: { alpha3: 'ARM', name: 'Armenia', emoji: getFlagEmoji('AM') },
  aw: { alpha3: 'ABW', name: 'Aruba', emoji: getFlagEmoji('AW') },
  au: { alpha3: 'AUS', name: 'Australia', emoji: getFlagEmoji('AU') },
  at: { alpha3: 'AUT', name: 'Austria', emoji: getFlagEmoji('AT') },
  az: { alpha3: 'AZE', name: 'Azerbaijan', emoji: getFlagEmoji('AZ') },
  bs: { alpha3: 'BHS', name: 'Bahamas', emoji: getFlagEmoji('BS') },
  bh: { alpha3: 'BHR', name: 'Bahrain', emoji: getFlagEmoji('BH') },
  bd: { alpha3: 'BGD', name: 'Bangladesh', emoji: getFlagEmoji('BD') },
  bb: { alpha3: 'BRB', name: 'Barbados', emoji: getFlagEmoji('BB') },
  by: { alpha3: 'BLR', name: 'Belarus', emoji: getFlagEmoji('BY') },
  be: { alpha3: 'BEL', name: 'Belgium', emoji: getFlagEmoji('BE') },
  bz: { alpha3: 'BLZ', name: 'Belize', emoji: getFlagEmoji('BZ') },
  bj: { alpha3: 'BEN', name: 'Benin', emoji: getFlagEmoji('BJ') },
  bm: { alpha3: 'BMU', name: 'Bermuda', emoji: getFlagEmoji('BM') },
  bt: { alpha3: 'BTN', name: 'Bhutan', emoji: getFlagEmoji('BT') },
  bo: { alpha3: 'BOL', name: 'Bolivia', emoji: getFlagEmoji('BO') },
  bq: { alpha3: 'BES', name: 'Bonaire, Sint Eustatius and Saba', emoji: getFlagEmoji('BQ') },
  ba: { alpha3: 'BIH', name: 'Bosnia and Herzegovina', emoji: getFlagEmoji('BA') },
  bw: { alpha3: 'BWA', name: 'Botswana', emoji: getFlagEmoji('BW') },
  bv: { alpha3: 'BVT', name: 'Bouvet Island', emoji: getFlagEmoji('BV') },
  br: { alpha3: 'BRA', name: 'Brazil', emoji: getFlagEmoji('BR') },
  io: { alpha3: 'IOT', name: 'British Indian Ocean Territory', emoji: getFlagEmoji('IO') },
  bn: { alpha3: 'BRN', name: 'Brunei Darussalam', emoji: getFlagEmoji('BN') },
  bg: { alpha3: 'BGR', name: 'Bulgaria', emoji: getFlagEmoji('BG') },
  bf: { alpha3: 'BFA', name: 'Burkina Faso', emoji: getFlagEmoji('BF') },
  bi: { alpha3: 'BDI', name: 'Burundi', emoji: getFlagEmoji('BI') },
  cv: { alpha3: 'CPV', name: 'Cabo Verde', emoji: getFlagEmoji('CV') },
  kh: { alpha3: 'KHM', name: 'Cambodia', emoji: getFlagEmoji('KH') },
  cm: { alpha3: 'CMR', name: 'Cameroon', emoji: getFlagEmoji('CM') },
  ca: { alpha3: 'CAN', name: 'Canada', emoji: getFlagEmoji('CA') },
  ky: { alpha3: 'CYM', name: 'Cayman Islands', emoji: getFlagEmoji('KY') },
  cf: { alpha3: 'CAF', name: 'Central African Republic', emoji: getFlagEmoji('CF') },
  td: { alpha3: 'TCD', name: 'Chad', emoji: getFlagEmoji('TD') },
  cl: { alpha3: 'CHL', name: 'Chile', emoji: getFlagEmoji('CL') },
  cn: { alpha3: 'CHN', name: 'China', emoji: getFlagEmoji('CN') },
  cx: { alpha3: 'CXR', name: 'Christmas Island', emoji: getFlagEmoji('CX') },
  cc: { alpha3: 'CCK', name: 'Cocos (Keeling) Islands', emoji: getFlagEmoji('CC') },
  co: { alpha3: 'COL', name: 'Colombia', emoji: getFlagEmoji('CO') },
  km: { alpha3: 'COM', name: 'Comoros', emoji: getFlagEmoji('KM') },
  cg: { alpha3: 'COG', name: 'Congo', emoji: getFlagEmoji('CG') },
  cd: { alpha3: 'COD', name: 'Congo (Democratic Republic of the)', emoji: getFlagEmoji('CD') },
  ck: { alpha3: 'COK', name: 'Cook Islands', emoji: getFlagEmoji('CK') },
  cr: { alpha3: 'CRI', name: 'Costa Rica', emoji: getFlagEmoji('CR') },
  ci: { alpha3: 'CIV', name: "Côte d'Ivoire", emoji: getFlagEmoji('CI') },
  hr: { alpha3: 'HRV', name: 'Croatia', emoji: getFlagEmoji('HR') },
  cu: { alpha3: 'CUB', name: 'Cuba', emoji: getFlagEmoji('CU') },
  cw: { alpha3: 'CUW', name: 'Curaçao', emoji: getFlagEmoji('CW') },
  cy: { alpha3: 'CYP', name: 'Cyprus', emoji: getFlagEmoji('CY') },
  cz: { alpha3: 'CZE', name: 'Czechia', emoji: getFlagEmoji('CZ') },
  dk: { alpha3: 'DNK', name: 'Denmark', emoji: getFlagEmoji('DK') },
  dj: { alpha3: 'DJI', name: 'Djibouti', emoji: getFlagEmoji('DJ') },
  dm: { alpha3: 'DMA', name: 'Dominica', emoji: getFlagEmoji('DM') },
  do: { alpha3: 'DOM', name: 'Dominican Republic', emoji: getFlagEmoji('DO') },
  ec: { alpha3: 'ECU', name: 'Ecuador', emoji: getFlagEmoji('EC') },
  eg: { alpha3: 'EGY', name: 'Egypt', emoji: getFlagEmoji('EG') },
  sv: { alpha3: 'SLV', name: 'El Salvador', emoji: getFlagEmoji('SV') },
  gq: { alpha3: 'GNQ', name: 'Equatorial Guinea', emoji: getFlagEmoji('GQ') },
  er: { alpha3: 'ERI', name: 'Eritrea', emoji: getFlagEmoji('ER') },
  ee: { alpha3: 'EST', name: 'Estonia', emoji: getFlagEmoji('EE') },
  sz: { alpha3: 'SWZ', name: 'Eswatini', emoji: getFlagEmoji('SZ') },
  et: { alpha3: 'ETH', name: 'Ethiopia', emoji: getFlagEmoji('ET') },
  fk: { alpha3: 'FLK', name: 'Falkland Islands (Malvinas)', emoji: getFlagEmoji('FK') },
  fo: { alpha3: 'FRO', name: 'Faroe Islands', emoji: getFlagEmoji('FO') },
  fj: { alpha3: 'FJI', name: 'Fiji', emoji: getFlagEmoji('FJ') },
  fi: { alpha3: 'FIN', name: 'Finland', emoji: getFlagEmoji('FI') },
  fr: { alpha3: 'FRA', name: 'France', emoji: getFlagEmoji('FR') },
  gf: { alpha3: 'GUF', name: 'French Guiana', emoji: getFlagEmoji('GF') },
  pf: { alpha3: 'PYF', name: 'French Polynesia', emoji: getFlagEmoji('PF') },
  tf: { alpha3: 'ATF', name: 'French Southern Territories', emoji: getFlagEmoji('TF') },
  ga: { alpha3: 'GAB', name: 'Gabon', emoji: getFlagEmoji('GA') },
  gm: { alpha3: 'GMB', name: 'Gambia', emoji: getFlagEmoji('GM') },
  ge: { alpha3: 'GEO', name: 'Georgia', emoji: getFlagEmoji('GE') },
  de: { alpha3: 'DEU', name: 'Germany', emoji: getFlagEmoji('DE') },
  gh: { alpha3: 'GHA', name: 'Ghana', emoji: getFlagEmoji('GH') },
  gi: { alpha3: 'GIB', name: 'Gibraltar', emoji: getFlagEmoji('GI') },
  gr: { alpha3: 'GRC', name: 'Greece', emoji: getFlagEmoji('GR') },
  gl: { alpha3: 'GRL', name: 'Greenland', emoji: getFlagEmoji('GL') },
  gd: { alpha3: 'GRD', name: 'Grenada', emoji: getFlagEmoji('GD') },
  gp: { alpha3: 'GLP', name: 'Guadeloupe', emoji: getFlagEmoji('GP') },
  gu: { alpha3: 'GUM', name: 'Guam', emoji: getFlagEmoji('GU') },
  gt: { alpha3: 'GTM', name: 'Guatemala', emoji: getFlagEmoji('GT') },
  gg: { alpha3: 'GGY', name: 'Guernsey', emoji: getFlagEmoji('GG') },
  gn: { alpha3: 'GIN', name: 'Guinea', emoji: getFlagEmoji('GN') },
  gw: { alpha3: 'GNB', name: 'Guinea-Bissau', emoji: getFlagEmoji('GW') },
  gy: { alpha3: 'GUY', name: 'Guyana', emoji: getFlagEmoji('GY') },
  ht: { alpha3: 'HTI', name: 'Haiti', emoji: getFlagEmoji('HT') },
  hm: { alpha3: 'HMD', name: 'Heard Island and McDonald Islands', emoji: getFlagEmoji('HM') },
  va: { alpha3: 'VAT', name: 'Holy See', emoji: getFlagEmoji('VA') },
  hn: { alpha3: 'HND', name: 'Honduras', emoji: getFlagEmoji('HN') },
  hk: { alpha3: 'HKG', name: 'Hong Kong', emoji: getFlagEmoji('HK') },
  hu: { alpha3: 'HUN', name: 'Hungary', emoji: getFlagEmoji('HU') },
  is: { alpha3: 'ISL', name: 'Iceland', emoji: getFlagEmoji('IS') },
  in: { alpha3: 'IND', name: 'India', emoji: getFlagEmoji('IN') },
  id: { alpha3: 'IDN', name: 'Indonesia', emoji: getFlagEmoji('ID') },
  ir: { alpha3: 'IRN', name: 'Iran', emoji: getFlagEmoji('IR') },
  iq: { alpha3: 'IRQ', name: 'Iraq', emoji: getFlagEmoji('IQ') },
  ie: { alpha3: 'IRL', name: 'Ireland', emoji: getFlagEmoji('IE') },
  im: { alpha3: 'IMN', name: 'Isle of Man', emoji: getFlagEmoji('IM') },
  il: { alpha3: 'ISR', name: 'Israel', emoji: getFlagEmoji('IL') },
  it: { alpha3: 'ITA', name: 'Italy', emoji: getFlagEmoji('IT') },
  jm: { alpha3: 'JAM', name: 'Jamaica', emoji: getFlagEmoji('JM') },
  jp: { alpha3: 'JPN', name: 'Japan', emoji: getFlagEmoji('JP') },
  je: { alpha3: 'JEY', name: 'Jersey', emoji: getFlagEmoji('JE') },
  jo: { alpha3: 'JOR', name: 'Jordan', emoji: getFlagEmoji('JO') },
  kz: { alpha3: 'KAZ', name: 'Kazakhstan', emoji: getFlagEmoji('KZ') },
  ke: { alpha3: 'KEN', name: 'Kenya', emoji: getFlagEmoji('KE') },
  ki: { alpha3: 'KIR', name: 'Kiribati', emoji: getFlagEmoji('KI') },
  kp: { alpha3: 'PRK', name: "Korea (Democratic People's Republic of)", emoji: getFlagEmoji('KP') },
  kr: { alpha3: 'KOR', name: 'Korea (Republic of)', emoji: getFlagEmoji('KR') },
  kw: { alpha3: 'KWT', name: 'Kuwait', emoji: getFlagEmoji('KW') },
  kg: { alpha3: 'KGZ', name: 'Kyrgyzstan', emoji: getFlagEmoji('KG') },
  la: { alpha3: 'LAO', name: "Lao People's Democratic Republic", emoji: getFlagEmoji('LA') },
  lv: { alpha3: 'LVA', name: 'Latvia', emoji: getFlagEmoji('LV') },
  lb: { alpha3: 'LBN', name: 'Lebanon', emoji: getFlagEmoji('LB') },
  ls: { alpha3: 'LSO', name: 'Lesotho', emoji: getFlagEmoji('LS') },
  lr: { alpha3: 'LBR', name: 'Liberia', emoji: getFlagEmoji('LR') },
  ly: { alpha3: 'LBY', name: 'Libya', emoji: getFlagEmoji('LY') },
  li: { alpha3: 'LIE', name: 'Liechtenstein', emoji: getFlagEmoji('LI') },
  lt: { alpha3: 'LTU', name: 'Lithuania', emoji: getFlagEmoji('LT') },
  lu: { alpha3: 'LUX', name: 'Luxembourg', emoji: getFlagEmoji('LU') },
  mo: { alpha3: 'MAC', name: 'Macao', emoji: getFlagEmoji('MO') },
  mg: { alpha3: 'MDG', name: 'Madagascar', emoji: getFlagEmoji('MG') },
  mw: { alpha3: 'MWI', name: 'Malawi', emoji: getFlagEmoji('MW') },
  my: { alpha3: 'MYS', name: 'Malaysia', emoji: getFlagEmoji('MY') },
  mv: { alpha3: 'MDV', name: 'Maldives', emoji: getFlagEmoji('MV') },
  ml: { alpha3: 'MLI', name: 'Mali', emoji: getFlagEmoji('ML') },
  mt: { alpha3: 'MLT', name: 'Malta', emoji: getFlagEmoji('MT') },
  mh: { alpha3: 'MHL', name: 'Marshall Islands', emoji: getFlagEmoji('MH') },
  mq: { alpha3: 'MTQ', name: 'Martinique', emoji: getFlagEmoji('MQ') },
  mr: { alpha3: 'MRT', name: 'Mauritania', emoji: getFlagEmoji('MR') },
  mu: { alpha3: 'MUS', name: 'Mauritius', emoji: getFlagEmoji('MU') },
  yt: { alpha3: 'MYT', name: 'Mayotte', emoji: getFlagEmoji('YT') },
  mx: { alpha3: 'MEX', name: 'Mexico', emoji: getFlagEmoji('MX') },
  fm: { alpha3: 'FSM', name: 'Micronesia (Federated States of)', emoji: getFlagEmoji('FM') },
  md: { alpha3: 'MDA', name: 'Moldova', emoji: getFlagEmoji('MD') },
  mc: { alpha3: 'MCO', name: 'Monaco', emoji: getFlagEmoji('MC') },
  mn: { alpha3: 'MNG', name: 'Mongolia', emoji: getFlagEmoji('MN') },
  me: { alpha3: 'MNE', name: 'Montenegro', emoji: getFlagEmoji('ME') },
  ms: { alpha3: 'MSR', name: 'Montserrat', emoji: getFlagEmoji('MS') },
  ma: { alpha3: 'MAR', name: 'Morocco', emoji: getFlagEmoji('MA') },
  mz: { alpha3: 'MOZ', name: 'Mozambique', emoji: getFlagEmoji('MZ') },
  mm: { alpha3: 'MMR', name: 'Myanmar', emoji: getFlagEmoji('MM') },
  na: { alpha3: 'NAM', name: 'Namibia', emoji: getFlagEmoji('NA') },
  nr: { alpha3: 'NRU', name: 'Nauru', emoji: getFlagEmoji('NR') },
  np: { alpha3: 'NPL', name: 'Nepal', emoji: getFlagEmoji('NP') },
  nl: { alpha3: 'NLD', name: 'Netherlands', emoji: getFlagEmoji('NL') },
  nc: { alpha3: 'NCL', name: 'New Caledonia', emoji: getFlagEmoji('NC') },
  nz: { alpha3: 'NZL', name: 'New Zealand', emoji: getFlagEmoji('NZ') },
  ni: { alpha3: 'NIC', name: 'Nicaragua', emoji: getFlagEmoji('NI') },
  ne: { alpha3: 'NER', name: 'Niger', emoji: getFlagEmoji('NE') },
  ng: { alpha3: 'NGA', name: 'Nigeria', emoji: getFlagEmoji('NG') },
  nu: { alpha3: 'NIU', name: 'Niue', emoji: getFlagEmoji('NU') },
  nf: { alpha3: 'NFK', name: 'Norfolk Island', emoji: getFlagEmoji('NF') },
  mk: { alpha3: 'MKD', name: 'North Macedonia', emoji: getFlagEmoji('MK') },
  mp: { alpha3: 'MNP', name: 'Northern Mariana Islands', emoji: getFlagEmoji('MP') },
  no: { alpha3: 'NOR', name: 'Norway', emoji: getFlagEmoji('NO') },
  om: { alpha3: 'OMN', name: 'Oman', emoji: getFlagEmoji('OM') },
  pk: { alpha3: 'PAK', name: 'Pakistan', emoji: getFlagEmoji('PK') },
  pw: { alpha3: 'PLW', name: 'Palau', emoji: getFlagEmoji('PW') },
  ps: { alpha3: 'PSE', name: 'Palestine, State of', emoji: getFlagEmoji('PS') },
  pa: { alpha3: 'PAN', name: 'Panama', emoji: getFlagEmoji('PA') },
  pg: { alpha3: 'PNG', name: 'Papua New Guinea', emoji: getFlagEmoji('PG') },
  py: { alpha3: 'PRY', name: 'Paraguay', emoji: getFlagEmoji('PY') },
  pe: { alpha3: 'PER', name: 'Peru', emoji: getFlagEmoji('PE') },
  ph: { alpha3: 'PHL', name: 'Philippines', emoji: getFlagEmoji('PH') },
  pn: { alpha3: 'PCN', name: 'Pitcairn', emoji: getFlagEmoji('PN') },
  pl: { alpha3: 'POL', name: 'Poland', emoji: getFlagEmoji('PL') },
  pt: { alpha3: 'PRT', name: 'Portugal', emoji: getFlagEmoji('PT') },
  pr: { alpha3: 'PRI', name: 'Puerto Rico', emoji: getFlagEmoji('PR') },
  qa: { alpha3: 'QAT', name: 'Qatar', emoji: getFlagEmoji('QA') },
  re: { alpha3: 'REU', name: 'Réunion', emoji: getFlagEmoji('RE') },
  ro: { alpha3: 'ROU', name: 'Romania', emoji: getFlagEmoji('RO') },
  ru: { alpha3: 'RUS', name: 'Russian Federation', emoji: getFlagEmoji('RU') },
  rw: { alpha3: 'RWA', name: 'Rwanda', emoji: getFlagEmoji('RW') },
  bl: { alpha3: 'BLM', name: 'Saint Barthélemy', emoji: getFlagEmoji('BL') },
  sh: { alpha3: 'SHN', name: 'Saint Helena, Ascension and Tristan da Cunha', emoji: getFlagEmoji('SH') },
  kn: { alpha3: 'KNA', name: 'Saint Kitts and Nevis', emoji: getFlagEmoji('KN') },
  lc: { alpha3: 'LCA', name: 'Saint Lucia', emoji: getFlagEmoji('LC') },
  mf: { alpha3: 'MAF', name: 'Saint Martin (French part)', emoji: getFlagEmoji('MF') },
  pm: { alpha3: 'SPM', name: 'Saint Pierre and Miquelon', emoji: getFlagEmoji('PM') },
  vc: { alpha3: 'VCT', name: 'Saint Vincent and the Grenadines', emoji: getFlagEmoji('VC') },
  ws: { alpha3: 'WSM', name: 'Samoa', emoji: getFlagEmoji('WS') },
  sm: { alpha3: 'SMR', name: 'San Marino', emoji: getFlagEmoji('SM') },
  st: { alpha3: 'STP', name: 'Sao Tome and Principe', emoji: getFlagEmoji('ST') },
  sa: { alpha3: 'SAU', name: 'Saudi Arabia', emoji: getFlagEmoji('SA') },
  sn: { alpha3: 'SEN', name: 'Senegal', emoji: getFlagEmoji('SN') },
  rs: { alpha3: 'SRB', name: 'Serbia', emoji: getFlagEmoji('RS') },
  sc: { alpha3: 'SYC', name: 'Seychelles', emoji: getFlagEmoji('SC') },
  sl: { alpha3: 'SLE', name: 'Sierra Leone', emoji: getFlagEmoji('SL') },
  sg: { alpha3: 'SGP', name: 'Singapore', emoji: getFlagEmoji('SG') },
  sx: { alpha3: 'SXM', name: 'Sint Maarten (Dutch part)', emoji: getFlagEmoji('SX') },
  sk: { alpha3: 'SVK', name: 'Slovakia', emoji: getFlagEmoji('SK') },
  si: { alpha3: 'SVN', name: 'Slovenia', emoji: getFlagEmoji('SI') },
  sb: { alpha3: 'SLB', name: 'Solomon Islands', emoji: getFlagEmoji('SB') },
  so: { alpha3: 'SOM', name: 'Somalia', emoji: getFlagEmoji('SO') },
  za: { alpha3: 'ZAF', name: 'South Africa', emoji: getFlagEmoji('ZA') },
  gs: { alpha3: 'SGS', name: 'South Georgia and the South Sandwich Islands', emoji: getFlagEmoji('GS') },
  ss: { alpha3: 'SSD', name: 'South Sudan', emoji: getFlagEmoji('SS') },
  es: { alpha3: 'ESP', name: 'Spain', emoji: getFlagEmoji('ES') },
  lk: { alpha3: 'LKA', name: 'Sri Lanka', emoji: getFlagEmoji('LK') },
  sd: { alpha3: 'SDN', name: 'Sudan', emoji: getFlagEmoji('SD') },
  sr: { alpha3: 'SUR', name: 'Suriname', emoji: getFlagEmoji('SR') },
  sj: { alpha3: 'SJM', name: 'Svalbard and Jan Mayen', emoji: getFlagEmoji('SJ') },
  se: { alpha3: 'SWE', name: 'Sweden', emoji: getFlagEmoji('SE') },
  ch: { alpha3: 'CHE', name: 'Switzerland', emoji: getFlagEmoji('CH') },
  sy: { alpha3: 'SYR', name: 'Syrian Arab Republic', emoji: getFlagEmoji('SY') },
  tw: { alpha3: 'TWN', name: 'Taiwan', emoji: getFlagEmoji('TW') },
  tj: { alpha3: 'TJK', name: 'Tajikistan', emoji: getFlagEmoji('TJ') },
  tz: { alpha3: 'TZA', name: 'Tanzania', emoji: getFlagEmoji('TZ') },
  th: { alpha3: 'THA', name: 'Thailand', emoji: getFlagEmoji('TH') },
  tl: { alpha3: 'TLS', name: 'Timor-Leste', emoji: getFlagEmoji('TL') },
  tg: { alpha3: 'TGO', name: 'Togo', emoji: getFlagEmoji('TG') },
  tk: { alpha3: 'TKL', name: 'Tokelau', emoji: getFlagEmoji('TK') },
  to: { alpha3: 'TON', name: 'Tonga', emoji: getFlagEmoji('TO') },
  tt: { alpha3: 'TTO', name: 'Trinidad and Tobago', emoji: getFlagEmoji('TT') },
  tn: { alpha3: 'TUN', name: 'Tunisia', emoji: getFlagEmoji('TN') },
  tr: { alpha3: 'TUR', name: 'Turkey', emoji: getFlagEmoji('TR') },
  tm: { alpha3: 'TKM', name: 'Turkmenistan', emoji: getFlagEmoji('TM') },
  tc: { alpha3: 'TCA', name: 'Turks and Caicos Islands', emoji: getFlagEmoji('TC') },
  tv: { alpha3: 'TUV', name: 'Tuvalu', emoji: getFlagEmoji('TV') },
  ug: { alpha3: 'UGA', name: 'Uganda', emoji: getFlagEmoji('UG') },
  ua: { alpha3: 'UKR', name: 'Ukraine', emoji: getFlagEmoji('UA') },
  ae: { alpha3: 'ARE', name: 'United Arab Emirates', emoji: getFlagEmoji('AE') },
  gb: { alpha3: 'GBR', name: 'United Kingdom', emoji: getFlagEmoji('GB') },
  um: { alpha3: 'UMI', name: 'United States Minor Outlying Islands', emoji: getFlagEmoji('UM') },
  us: { alpha3: 'USA', name: 'United States', emoji: getFlagEmoji('US') },
  uy: { alpha3: 'URY', name: 'Uruguay', emoji: getFlagEmoji('UY') },
  uz: { alpha3: 'UZB', name: 'Uzbekistan', emoji: getFlagEmoji('UZ') },
  vu: { alpha3: 'VUT', name: 'Vanuatu', emoji: getFlagEmoji('VU') },
  ve: { alpha3: 'VEN', name: 'Venezuela', emoji: getFlagEmoji('VE') },
  vn: { alpha3: 'VNM', name: 'Viet Nam', emoji: getFlagEmoji('VN') },
  vg: { alpha3: 'VGB', name: 'Virgin Islands (British)', emoji: getFlagEmoji('VG') },
  vi: { alpha3: 'VIR', name: 'Virgin Islands (U.S.)', emoji: getFlagEmoji('VI') },
  wf: { alpha3: 'WLF', name: 'Wallis and Futuna', emoji: getFlagEmoji('WF') },
  eh: { alpha3: 'ESH', name: 'Western Sahara', emoji: getFlagEmoji('EH') },
  ye: { alpha3: 'YEM', name: 'Yemen', emoji: getFlagEmoji('YE') },
  zm: { alpha3: 'ZMB', name: 'Zambia', emoji: getFlagEmoji('ZM') },
  zw: { alpha3: 'ZWE', name: 'Zimbabwe', emoji: getFlagEmoji('ZW') },
};

const findCountryNameByAlpha2Code = (alpha2: string): string | undefined => {
  const lowerAlpha2 = alpha2?.trim().toLowerCase();
  return countries[lowerAlpha2 as keyof typeof countries]?.name || undefined;
};

const validCountryAlpha2Code = (alpha2: string): keyof typeof countries | undefined => {
  const lowerAlpha2 = alpha2?.trim().toLowerCase();
  return countries[lowerAlpha2 as keyof typeof countries] ? (lowerAlpha2 as keyof typeof countries) : undefined;
};

const findCountryFlagEmojiByAlpha2Code = (alpha2: string): string | undefined => {
  const lowerAlpha2 = alpha2?.trim().toLowerCase();
  return countries[lowerAlpha2 as keyof typeof countries]?.emoji || undefined;
};

const countryAlpha2Codes = Object.keys(countries) as Array<keyof typeof countries>;

export { findCountryNameByAlpha2Code, validCountryAlpha2Code, findCountryFlagEmojiByAlpha2Code, countryAlpha2Codes };
